import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { useDashboardSummary } from "../useMonitoringApi";

export function MonitoringCheckTypeFilter() {
  const { clearParam, setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data } = useDashboardSummary();

  const options = (data?.monitorable_check_types ?? []).map((option) => ({
    id: option.type,
    name: option.label || option.type,
  }));

  if (options.length === 0) {
    return null;
  }

  return (
    <Picker
      label={t("Check monitored")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.check_type?.split(",") || []}
      onSelectionChange={(keys) => {
        clearParam("page");
        setParam("check_type", Array.from(keys));
      }}
      items={options}
      testID="monitoring-check-type-filter-picker"
    />
  );
}
